import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { SocialIcons } from "@/components/Social";

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", f);
      toast.success("Message sent. We'll be in touch soon.");
      setF({ name: "", email: "", message: "" });
    } catch { toast.error("Something went wrong. Try again."); }
    setBusy(false);
  };
  return (
    <div className="max-w-6xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-16" data-testid="contact-page">
      <div>
        <div className="text-eyebrow">Say hello</div>
        <h1 className="font-heading text-5xl md:text-6xl mt-4">Let's talk.</h1>
        <p className="text-neutral-600 mt-6 leading-relaxed">Attending, hosting, partnering, or just curious — drop us a line.</p>
        <div className="mt-10 space-y-4 text-neutral-700">
          <div className="text-eyebrow">Reach us</div>
          <div>hello@offlineandavailable.com</div>
        </div>
        <div className="mt-8">
          <div className="text-eyebrow mb-3">Follow along</div>
          <SocialIcons size={24} gap="gap-6" className="text-neutral-800" />
          <p className="text-neutral-500 text-sm mt-4 leading-relaxed max-w-sm">Follow us on Facebook, Instagram, and TikTok for the latest event schedule, ticket releases, and announcements.</p>
        </div>
      </div>
      <form onSubmit={submit} className="card-elegant p-8 space-y-4">
        <Input placeholder="Your name" value={f.name} onChange={e=>setF({...f, name: e.target.value})} required data-testid="contact-name" className="rounded-xl" />
        <Input type="email" placeholder="Email" value={f.email} onChange={e=>setF({...f, email: e.target.value})} required data-testid="contact-email" className="rounded-xl" />
        <Textarea rows={5} placeholder="Your message" value={f.message} onChange={e=>setF({...f, message: e.target.value})} required data-testid="contact-message" className="rounded-xl" />
        <Button type="submit" disabled={busy} className="w-full rounded-full bg-black text-white hover:bg-neutral-800 btn-pill" data-testid="contact-submit">
          {busy ? "Sending…" : "Send message"}
        </Button>
      </form>
    </div>
  );
}
